import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { observer, inject } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import Paragraph from '@components/Details/Paragraph'
import InfoPanel from './InfoPanel'
import Actions from './Actions'
import PropTypes from 'prop-types'
import { formatDate } from '@atheneum/api/dist/lib'
import { userApi } from '@atheneum/api'

import Spinner from '@components/spinner'
import Scroll from '@components/Scroll'
import Header from './Header'

import ProfileStore from './profile.store'

class ProfilePage extends Component {
  constructor (props) {
    super(props)

    extendObservable(this, {
      profileStore: new ProfileStore()
    })

    this.profileStore.getProfile(props.userStore.user.id)
  }
  handleResetPassword = () => {
    const { userStore, growlStore } = this.props
    const { email } = userStore.user

    return userApi.forgotPassword({ email })
      .then(res => {
        growlStore.showSuccess('Reset password link sent.')
      })
      .catch(err => {
        growlStore.showError(err.message)
      })
  }

  render () {
    const { profile, loading } = this.profileStore

    if (loading) {
      return <Spinner />
    }
    return (
      <DocumentTitle title={`My profile | Atheneum Partners`}>
        <Scroll>
          <div className='expert-wrapper profile-page'>
            <Header profileStore={this.profileStore} />
            <div className='details-wrapper'>
              <Actions profileStore={this.profileStore} />
              <InfoPanel profile={profile} />
              <div className='employee-section'>
                <h2>Employee expertise</h2>
                <Paragraph value={profile.employee.expertize} />
              </div>
              <div className='comments-wrapper'>
                <p className='independent-label'>
                  <span>Last login:</span> {formatDate(profile.lastLogin)}
                </p>
                <p className='independent-label'>
                  <span>Date created:</span> {formatDate(profile.created_at)}
                </p>
                <p
                  className='independent-label independent-label--blue'
                  onClick={this.handleResetPassword}
                >
                  Reset password
                </p>
              </div>
            </div>
          </div>
        </Scroll>
      </DocumentTitle>
    )
  }

  static propTypes = {
    userStore: PropTypes.object,
    growlStore: PropTypes.object
  }
}

export default inject('userStore', 'growlStore')(observer(ProfilePage))
